import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { PAGE_TYPE, setPageTitle } from "containers/App/reducer";

import equal from "fast-deep-equal";
import queryString from "query-string";

import * as homeReducer from "containers/Home/reducer";
import * as galleryReducer from "containers/Gallery/GalleryReducer";
import * as reportReducer from "containers/Report/ReportReducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as projectReducer from "containers/Project/reducer";
import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";
import * as nextTransformReducer from "containers/Next/Transform/TransformReducer";
import * as nextOverviewReducer from "containers/Next/Overview/OverviewReducer";
import * as globalReducer from "containers/App/reducer";
import * as viewReducer from "containers/View/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as marketReducer from "containers/Market/MarketReducer";
import * as deploymentsReducer from "containers/Deployments/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as monitoringReducer from "containers/Monitoring/reducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import WizardContainer from "containers/Wizard/Wizard";

import Next from "components/Next/Next";

function getReportIdFromRoute(route) {
  if (!route) {
    return undefined;
  }

  const routeComponents = route?.split("/");
  const REPORT_ID_INDEX = 3;

  return routeComponents?.[REPORT_ID_INDEX];
}

const getId = (props) =>
  props && props.reportId
    ? props.reportId
    : props && props.match && props.match.params && props.match.params.reportId
      ? props.match.params.reportId
      : "new";

const getDatasetId = (props) =>
  props && props.datasetId
    ? props.datasetId
    : props && props.match && props.match.params && props.match.params.datasetId
      ? props.match.params.datasetId
      : "new";

const getBlueprintId = (props) =>
  props && props.blueprintId
    ? props.blueprintId
    : props && props.match && props.match.params && props.match.params.blueprintId
      ? props.match.params.blueprintId
      : undefined;

class NextContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { globalProjectId, updateCurrentProjectId, projectId, handleAddBlueprint, blueprint } = this.props;

    const id = getId(this.props);

    const name = this.props?.reportLabel ? this.props?.reportLabel : this.props?.report?.name;

    setPageTitle(PAGE_TYPE.PROJECT, id, name);

    if (projectId !== globalProjectId) {
      updateCurrentProjectId(projectId);
    }

    const queryParams = this.props.location.search;
    const paramsObj = queryParams ? queryString.parse(queryParams) : undefined;
    const currId = getId(this.props);

    if (currId === "new" && !isNaN(paramsObj?.blueprintId)) {
      handleAddBlueprint(paramsObj.blueprintId);
    }
  }

  componentDidUpdate(prevProps) {
    const currId = getId(this.props);
    const prevId = getId(prevProps);

    const currName = this.props?.reportLabel ? this.props?.reportLabel : this.props?.report?.name;
    const prevName = prevProps?.reportLabel ? prevProps?.reportLabel : prevProps?.report?.name;

    if (currId !== prevId || currName !== prevName) {
      setPageTitle(PAGE_TYPE.PROJECT, currId, currName);
    }
  }

  shouldComponentUpdate(nextProps) {
    const isEqual = equal(this.props, nextProps);

    return isEqual === true ? false : true;
  }

  componentWillUnmount() {
    const { updateCurrentProjectId, clearAutosave } = this.props;
    updateCurrentProjectId(undefined);
    clearAutosave();
  }

  render() {
    return <Next {...this.props} />;
  }
}

// We have to be able to access state to get the ID
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    dispatch: dispatch
  };
};

// Oh god whyyyyyy
const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const dispatch = dispatchProps?.dispatch;
  const id = stateProps.id;

  return {
    ...stateProps,
    ...dispatchProps,
    init: (id, datasetId, blueprintId) => dispatch(nextReducer.init(id, datasetId, true, blueprintId)),

    saveAsPpt: () => dispatch(nextReducer.generateExplorationPowerpoint(id)),
    saveNext: (saveMessage) => dispatch(nextReducer.saveNext(id, saveMessage)),

    exportToPowerpointProject: () => dispatch(nextReducer.exportToPowerpointProject(id)),

    changeOutcome: (outcome) => dispatch(homeReducer.changeOutcome(id, outcome)),

    createReport: (label, chart) => dispatch(reportReducer.createReport(label, id, chart)),
    addChartToReport: (reportId, chart) => dispatch(reportReducer.addChartToReport(reportId, id, chart)),
    createLinkedReport: (report) => dispatch(reportReducer.createLinkedReport(report)),

    updateHexSize: (hexSize) => dispatch(nextReducer.updateHexSize(id, hexSize)),
    updateSelectedHex: (hex) => dispatch(nextReducer.updateSelectedHex(id, hex, hex)),
    updateHexMap: (hexMap) => dispatch(nextReducer.updateHexMap(id, hexMap)),
    updateSavedHexMap: () => dispatch(nextReducer.updateSavedHexMap(id)),

    updateCustomValue: (runId, blueprintId, valId, value) => {
      dispatch(setupReducer.updateCustomValue(runId, blueprintId, valId, value));
      dispatch(projectReducer.resetBudget(id, false, true));
    },

    resetNext: () => dispatch(nextReducer.updateNext(id, undefined)),

    resetActions: (isAnimate = true) => dispatch(nextReducer.resetActions(id, isAnimate)),

    updateSelectionDirection: (direction, isList = false) =>
      dispatch(nextReducer.updateSelectionDirection(id, direction, undefined, undefined, isList)),
    updateSelectedChart: (hex, node) => dispatch(nextReducer.updateSelectedChart(id, hex, node)),
    updateSearchChart: (hex, node) => dispatch(nextReducer.updateSearchChart(id, hex, node)),

    updateChartType: (chartType) => dispatch(nextReducer.updateChartType(id, chartType)),
    updateActiveTab: (activeTab) => dispatch(nextReducer.updateActiveTab(id, activeTab)),
    updateIsDistribution: (isDistribution) => dispatch(nextReducer.updateIsDistribution(id, isDistribution)),
    updateReportLabel: (reportLabel) =>
      dispatch(nextReducer.updateReportLabelAndContentGenerationCollection(id, reportLabel)),

    centerHex: (hex, isSmooth) => dispatch(nextReducer.centerHex(hex, isSmooth)),

    addNode: (node) => dispatch(nextReducer.addNode(id, node)),
    removeNode: (hex, node) => dispatch(nextReducer.removeNode(id, hex, node)),
    updateHover: (node) => dispatch(nextReducer.updateHover(id, node)),

    replayActions: (node) => dispatch(nextReducer.replayActions(id, node)),
    resetHex: () => dispatch(nextReducer.resetHex(id)),
    updateIsReplay: (isReplay) => dispatch(nextReducer.updateIsReplay(id, isReplay)),
    updateShowReplay: (showReplay) => dispatch(nextReducer.updateShowReplay(id, showReplay)),
    updateIsComment: (isComment) => dispatch(nextReducer.updateIsComment(id, isComment)),
    updateIsTasks: (isTasks) => dispatch(nextReducer.updateIsTasks(id, isTasks)),

    updateIsLeftClosed: (isLeftClosed) => dispatch(nextReducer.updateIsLeftClosed(id, isLeftClosed)),

    handleUpdate: (hex, node) => dispatch(nextModelsReducer.handleUpdate(id, hex, node)),
    handleBackModels: (projectId, stopReset) => {
      dispatch(nextModelsReducer.handleBack(id, stopReset));
      if (projectId) dispatch(projectReducer.resetBudget(projectId));
    },
    assignTodo: (todo) => dispatch(nextModelsReducer.assignTodo(id, todo)),
    updateMarkCompleted: (node) => dispatch(nextModelsReducer.updateMarkCompleted(id, node)),
    handleStartBreadcrumbs: (node) => dispatch(nextModelsReducer.handleStartBreadcrumbs(id, node)),
    updateIsGuided: () => dispatch(viewReducer.updateIsGuided(false)),
    updateIsReviewingJob: (isReviewing) => dispatch(marketReducer.updateIsReviewingJob(isReviewing)),
    updatePinnedHex: (pinnedHex) => dispatch(nextModelsReducer.updatePinnedHex(id, pinnedHex)),
    saveBlueprint: (blueprintId) => dispatch(nextModelsReducer.saveBlueprint(id, blueprintId)),

    editNodeAssign: (node, edits, tIndex, isDelete) =>
      dispatch(nextModelsReducer.editNodeAssign(id, node, edits, tIndex, isDelete)),

    editComment: (node, edits, tIndex, isDelete) =>
      dispatch(nextModelsReducer.editComment(id, node, edits, tIndex, isDelete)),

    editFeedback: (node, edits) => dispatch(nextReducer.editFeedback(id, node, edits)),
    deleteFeedback: (node, edits) => dispatch(nextReducer.deleteFeedback(id, node, edits)),

    updateViewTask: (viewTask) => dispatch(nextModelsReducer.updateViewTask(id, viewTask)),
    updateIsTodo: (isTodo) => dispatch(nextModelsReducer.updateIsTodo(id, isTodo)),
    updateTodoMaximize: (todoMaximize) => dispatch(nextModelsReducer.updateTodoMaximize(id, todoMaximize)),
    deploy: (projectId) => dispatch(projectReducer.deploy(projectId, true)),

    updateIsCommentModal: (isCommentModal) => dispatch(nextModelsReducer.updateIsCommentModal(id, isCommentModal)),
    updateIsEditBlueprint: (isEditBlueprint) => dispatch(nextModelsReducer.updateIsEditBlueprint(id, isEditBlueprint)),
    saveUpdateBlueprint: () => dispatch(nextModelsReducer.saveUpdateBlueprint(id)),
    rejectTask: (viewTask) => dispatch(nextModelsReducer.rejectTask(id, viewTask)),
    approveTask: (viewTask) => dispatch(nextModelsReducer.approveTask(id, viewTask)),
    deleteTask: (taskId) => dispatch(projectReducer.deleteTask(taskId)),
    retrainRun: (projectId) => dispatch(projectReducer.retrainRun(projectId)),
    approveTaskProject: (taskId) => dispatch(projectReducer.approveTask(taskId)),

    likeTask: (task) => dispatch(nextModelsReducer.likeTask(id, task)),
    dislikeTask: (task) => dispatch(nextModelsReducer.dislikeTask(id, task)),

    updateCurrentProjectId: (projectId) => dispatch(globalReducer.updateCurrentProjectId(projectId)),

    handleAddBlueprint: (blueprintId) => dispatch(nextTransformReducer.handleAddBlueprint("new", blueprintId)),

    updateExploreDefaultViewMode: (viewMode) => dispatch(nextReducer.updateExploreDefaultViewMode(viewMode)),
    chatGPTUpdateShowSettings: (showSettings) => dispatch(chatGPTReducer.updateShowSettings(showSettings)),

    updateChatRestrictChartsToPinned: (chatRestrictChartsToPinned) =>
      dispatch(chatGPTReducer.updateChatRestrictChartsToPinned(chatRestrictChartsToPinned)),
    clearAutosave: () => dispatch(nextReducer.clearAutosave(id))
  };
};
const mapStateToProps = (state, ownProps) => {
  // Workaround for match not updating on location change
  const route = state?.router?.location?.pathname;
  const routeId = getReportIdFromRoute(route);

  const id = ownProps.reportId ?? routeId ?? "new";

  const datasetId = getDatasetId(ownProps);
  const blueprintId = getBlueprintId(ownProps);
  const projectId = nextReducer.getProjectId(state, id);
  const exploreProjectId = nextReducer.getExploreProjectId(state, id);

  const optimized = projectReducer.getOptimized(state, projectId);

  const runId = optimized && optimized.innerId !== undefined ? optimized.innerId : id;

  const activeTab = nextReducer.getActiveTab(state, id);

  const hexMap =
    activeTab === "TRANSFORM"
      ? nextTransformReducer.getHexMap(state, id)
      : activeTab === "MODELS" || activeTab === "MONITOR"
        ? nextModelsReducer.getAllHex(state, id)
        : activeTab === "OVERVIEW"
          ? nextOverviewReducer.getHexMap(state, id)
          : activeTab === "EXPLORE"
            ? nextReducer.getHexMap(state, id)
            : ownProps?.isTile
              ? nextReducer.getHexMap(state, id)
              : nextReducer.getHexMap(state, id);

  const reportlabel = nextReducer.getReportLabel(state, id);
  const report = nextReducer.getNext(state, id);

  const nodeAssign = nextModelsReducer.getNodeAssign(state, id);
  const nodeAssignCount = Object.keys(nodeAssign).reduce((a, b) => a + nodeAssign[b].length, 0);

  const comments = nextModelsReducer.getComments(state, id);
  const commentCount = Object.keys(comments).reduce((a, b) => a + comments[b].length, 0);

  const exploreAssign = nextReducer.getNodeAssign(state, id);
  const exploreAssignCount = Object.keys(exploreAssign).reduce((a, b) => a + exploreAssign[b].length, 0);

  const exploreComments = nextReducer.getComments(state, id);
  const exploreCommentCount = Object.keys(exploreComments).reduce((a, b) => a + exploreComments[b].length, 0);

  const rSetup = setupReducer.getSetup(state, runId);

  const isNextBlueprintEdit = blueprintId === "new" || (blueprintId !== undefined && id === "new");

  const uiState = globalReducer.getUiState(state);
  const isShareLink = uiState?.type === "SHARE_LINK";

  return {
    path: state?.router?.location?.pathname,
    id: id,
    datasetId: datasetId,
    blueprintId: blueprintId,
    projectId: projectId,
    runId: runId,
    isNextBlueprintEdit: isNextBlueprintEdit,
    overallRunId: projectReducer.getOverallRunId(state, projectId),

    explorationKey: nextReducer.getExplorationKey(state, id),

    blueprint:
      blueprintId !== undefined
        ? blueprintReducer.getBlueprint(state, blueprintId)
        : rSetup.blueprintId !== undefined
          ? blueprintReducer.getBlueprint(state, rSetup.blueprintId)
          : undefined,

    dataset: homeReducer.getDataset(state, datasetId),
    datasetId: nextReducer.getDatasetId(state, id),
    datasetIsLoading: homeReducer.isLoading(state, datasetId),

    projectIsLoading: projectReducer.getIsLoadingProject(state, projectId),

    hasSplits: projectReducer.getHasSplits(state, projectId),
    hasSameScenario: projectReducer.getHasSameScenario(state, projectId),

    isSavingReport: nextReducer.getIsSavingReport(state, id),
    activeTab: nextReducer.getActiveTab(state, id),
    hexSize: nextReducer.getHexSize(state, id),
    innerHexSize: nextReducer.getInnerHexSize(state, id),
    hexagonRadius: nextReducer.getHexagonRadius(state, id),
    isComment: nextReducer.getIsComment(state, id),
    isTasks: nextReducer.getIsTasks(state, id),
    selectionDirectionCharts: nextReducer.getSelectionDirectionCharts(state, id),
    selectionDirection: nextReducer.getSelectionDirection(state, id),
    interactionsEvaluated: nextReducer.getInsightCombinationCount(state, id),
    isOpenSaveScenarioModal: nextReducer.getIsOpenSaveScenarioModal(state, id),

    tasks: projectReducer.getTasks(state, projectId),
    exploreTasks: projectReducer.getTasks(state, exploreProjectId),
    viewTask: nextModelsReducer.getViewTask(state, id),

    isOverallSegment: projectReducer.getIsOverallSegment(state, projectId),

    report: report,
    reportLabel: reportlabel,
    actionHexMap: nextReducer.getActionHexMap(state, id),
    hexMap: hexMap,
    savedHexMap: nextReducer.getSavedHexMap(state, id),
    savedTransformHexMap: nextTransformReducer.getSavedHexMap(state, id),
    selectedHex: nextReducer.getSelectedHex(state, id),
    selectedChart: nextReducer.getSelectedChart(state, id),

    selectedHexModels: nextModelsReducer.getSelectedHex(state, id),
    pinnedHex: nextModelsReducer.getPinnedHex(state, id),
    selectedHexTransform: nextTransformReducer.getSelectedHex(state, id),
    hasSetupChanged: nextModelsReducer.getHasSetupChanged(state, id),
    modelTodos: nextModelsReducer.getTodos(state, id, true),
    nodeAssign: nodeAssign,
    nodeAssignCount: nodeAssignCount,
    comments: comments,
    commentCount: commentCount,
    isSelectedTemporary: nextModelsReducer.getIsSelectedTemporary(state, id),
    isFixUpdate: nextModelsReducer.getIsFixUpdate(state, id),

    exploreAssign: exploreAssign,
    exploreAssignCount: exploreAssignCount,
    exploreComments: exploreComments,
    exploreCommentCount: exploreCommentCount,

    segmentColor: projectReducer.getSegmentColor(state, projectId),
    project: projectReducer.getProject(state, projectId),
    allScenarios: projectReducer.getAllScenarios(state, projectId),

    isReplay: nextReducer.getIsReplay(state, id),

    visibleActions: [],
    hasBeforeReplayHexMap: nextReducer.getHasBeforeReplayHexMap(state, id),
    showReplay: nextReducer.getShowReplay(state, id),
    replayIndex: 0,

    hasConsultantAction: nextModelsReducer.getHasConsultantAction(state, id),

    setupSection: nextModelsReducer.getSetupSection(state, id),
    isTodo: nextModelsReducer.getIsTodo(state, id),
    todoMaximize: nextModelsReducer.getTodoMaximize(state, id),
    isEditBlueprint: nextModelsReducer.getIsEditBlueprint(state, id),

    isTableauMode: globalReducer.getIsTableauMode(state, id),

    isLeftClosed: nextReducer.getIsLeftClosed(state, id),
    chartOrder: nextReducer.getChartOrder(state, id),

    nSetup: setupReducer.getSetup(state, "new"),
    isForecastProject: projectReducer.getIsForecastProject(state, projectId),

    replayInfo: {},
    isGuided: viewReducer.getIsGuided(state),

    optimized: optimized,
    optimizer: projectReducer.getOptimizer(state, projectId),
    modelGroups: projectReducer.getModelGroups(state, projectId),

    isReviewing: marketReducer.getIsReviewing(state),
    selectedScenario: projectReducer.getSelectedScenario(state, projectId),
    approvedScenario: projectReducer.getApprovedScenario(state, projectId, runId),
    hasSetupIgnoreChanged:
      optimized && optimized.innerId !== undefined ? setupReducer.getSetupIgnoreChanged(state, runId) : false,
    isRetraining: projectReducer.getIsRetraining(state, projectId),

    deployment: deploymentsReducer.getProjectDeployment(state, projectId),
    datasetSuccess: nextReducer.getDatasetSuccess(state, id),

    monitoringData: monitoringReducer.getData(state, projectId),
    segmentId: projectReducer.getSegmentId(state, projectId),

    searchInsights: nextReducer.getSearchInsights(state, id),
    searchOptions: nextReducer.getSearchOptions(state, id),
    isReportExpand: nextReducer.getIsReportExpand(state, id),

    pinnedHexList: nextReducer.getPinnedHexList(state, id),

    globalProjectId: globalReducer.getCurrentProjectId(state),
    comparisonOptions: nextReducer.getComparisonOptions(state, id),

    exploreDefaultViewMode: nextReducer.getExploreDefaultViewMode(state),
    chatGPTShowSettings: chatGPTReducer.getShowSettings(state),

    showHiddenCharts: nextReducer.getShowHiddenCharts(state, id),
    hiddenCHarts: nextReducer.getHiddenCharts(state, id),

    uiState: uiState,
    isShareLink: isShareLink,
    isSmallScreen: viewReducer.getIsSmallScreen(state),

    chatRestrictChartsToPinned: chatGPTReducer.getChatRestrictChartsToPinned(state),

    optimizeSetup: chatGPTReducer.getOptimizeSetup(state),
    optimizeSetupHasSplits: chatGPTReducer.getOptimizeSetupHasSplits(state),

    segmentSetups: projectReducer.getSegmentSetups(state, projectId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export default compose(withConnect, withRouter)(NextContainer);
